import { ClinicalFormsApi } from "clinical-forms-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { AxiosInstance } from "axios";
import { spire360ApiClient } from "./Spire360ApiClient";

export function createClinicalFormsApi(): ClinicalFormsApi {

  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';

  if(isGatewayEnabled){
    const basePath = process.env.REACT_APP_CLINICAL_API_URL_GATEWAY;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new ClinicalFormsApi(
      undefined,
      `${process.env.REACT_APP_CLINICAL_API_URL_GATEWAY}`,
      axiosInstance
    );

  }
  else{
    return new ClinicalFormsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_CLINICAL_API_URL}`
    );
  }
 
}
